import { apiFetch } from "./api";

export const getUsers = async () => {
    const obj = {
        method: 'POST',
        body: {
            option: 'get_users',
        }
    }

    const response = await apiFetch(obj);

    return response;
};
